<template>
    <span :class="[namespace(), skinStyle]" role="img" :alt="starAlt">
        <span v-if="value >= 1 && value <= 5">
            <svg
                v-for="index in stars"
                :key="index"
                :class="mdsNS('icon button__icon button_msstar')"
            >
                <use xlink:href="#star-fill">
                    <title>{{ starLabel }}</title>
                </use>
            </svg>
        </span>
        <span v-else>—</span>
    </span>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-star-rating',
    mixins: [mixins],
    props: {
        value: {
            type: [Number, String],
            default: 0
        },
        starLabel: {
            type: String,
            default: 'Star'
        },
        starsLabel: {
            type: String,
            default: 'Stars'
        }
    },
    computed: {
        skinStyle() {
            return this.namespace(`__${utils.getSkinSuffix(this.skin)}`);
        },
        stars() {
            const stars = [];
            for (let i = 1; i <= this.value; i++) {
                stars.push(i);
            }
            return stars;
        },
        starAlt() {
            if (this.value >= 1) {
                return this.value > 1
                    ? `${this.value} ${this.starsLabel}`
                    : this.starLabelstarLabel;
            } else {
                return '';
            }
        }
    },
    created() {
        this.namespace = utils.namespace('ui-star-rating', false);
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-star-rating';
.#{$namespace} {
    &__dark-gray {
        svg {
            fill: $mds-text-color-primary-on-dark;
        }
    }
}
</style>
